import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import styled from "styled-components";
import { clone, take } from "lodash";
import { Application } from "../applications/ApplicationsStore";

const CardActions = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 0.5rem 1rem 0.5rem 0rem;
    gap: 0.5rem;
`;

const ApplicationCardContainer = styled.div`
    width: 100%;
    background-color: #efefef;
    padding: 1rem;
    border-radius: 15px;
    box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
`;

const ApplicationCardHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    img {
        max-height: 50px;
        margin: 1rem;
    }

    div {
        font-size: 2rem;
    }
`;

const CardAction = styled.a`
    text-decoration: none;
    display: flex;
    div {
        margin-right: 0.5rem;
    }
`;

interface ApplicationDesign {
    title: string;
    logo: string;
    subTitle: string;
}

const ApplicationMap = {
    0: {
        title: "",
        logo: "",
    },
    1: {
        title: "Portal",
        logo: "/images/applications/scadsys.png",
    },
    2: {
        title: "Scadsys",
        logo: "/images/applications/scadsys.png",
    },
    3: {
        title: "Forms",
        logo: "/images/applications/forms.png",
    },
    4: {
        subTitle: "Online Store",
        logo: "/images/applications/shop.png",
    },
    5: {
        title: "Screening",
        logo: "/images/applications/screening.png",
    },
};

const applicationDesign = (app: Application): ApplicationDesign => {
    let design = clone(ApplicationMap[app.applicationType]) as ApplicationDesign;

    switch (app.name) {
        case "Scadsys educator portal":
            design.title = "Staff Portal";
            design.logo = "/images/applications/staff.png";
            break;
        case "Scadsys student portal":
            design.title = "Student Portal";
            design.logo = "/images/applications/student.png";
            break;
        case "Scadsys parent portal":
            design.title = "Parent Portal";
            design.logo = "/images/applications/parent.png";
            break;
    }

    switch (app.applicationType) {
        case 4:
            design.title = app.name;
            break;
        default:
            design.subTitle = app.name;
            break;
    }

    if (app.name == "RGB Gaming") {
        design.logo = "/images/applications/rgb.png";
    }

    return design;
};

let truncateText = (text: string, length: number) => {
    let parts = text.split(" ");
    let result = "";
    for (let i = 0; i < parts.length; i++) {
        if (result.length + parts[i].length > length) {
            break;
        } else {
            result += parts[i] + " ";
        }
    }

    if (result.length > length) {
        result = result.substring(0, length - 3);
    }

    if (text.length > length) {
        result += "...";
    }

    return result;
};

export let ApplicationCard = ({ app }: { app: Application }) => {
    let design = applicationDesign(app);

    return (
        <ApplicationCardContainer>
            <ApplicationCardHeader>
                <img src={design.logo || app.logo} />
                <div>{design.title}</div>
            </ApplicationCardHeader>
            <div>{design.subTitle}</div>
            <CardActions>
                {take(app.actions, 2).map((a, i) => (
                    <CardAction href={a.url} key={i}>
                        <div>{truncateText(a.text, 15)}</div>
                        
                        <FontAwesomeIcon size="lg" icon={["fad", a.icon]}></FontAwesomeIcon>
                    </CardAction>
                ))}
                {app.url && (
                    <CardAction href={app.url}>
                        <div>Go</div>
                        <FontAwesomeIcon size="lg" icon={["fad", "arrow-right"]}></FontAwesomeIcon>
                    </CardAction>
                )}
            </CardActions>
        </ApplicationCardContainer>
    );
};
